export const BI_SCHEMA = {
  app: {
    load: {
      start: {
        id: 119,
        name: 'app.load.start',
        fields: ['projectId', 'organizationId'],
      },

      finish: {
        id: 120,
        name: 'app.load.finish',
        fields: ['loadingTime', 'projectId', 'organizationId'],
      },
    },
  },

  page: {
    load: {
      id: 101,
      name: 'page load',
      fields: ['previousPage', 'pageName', 'referralUrl'],
    },
  },

  loginPage: {
    signIn: {
      click: {
        id: 103,
        name: 'loginPage.signIn.click',
        fields: ['referralUrl'],
      },
    },
  },

  createOrganization: {
    create: {
      click: {
        id: 104,
        name: 'createOrganization.create.click',
        fields: ['projectName', 'organizationName', 'referralUrl'],
      },
    },

    createFirst: {
      click: {
        id: 105,
        name: 'createOrganization.createFirst.click',
        fields: ['projectName', 'organizationName', 'referralUrl'],
      },
    },
  },

  organizationSelectPage: {
    select: {
      click: {
        id: 106,
        name: 'organizationSelectPage.select.click',
        fields: ['organizationName', 'organizationId'],
      },
    },

    createNewOrganization: {
      click: {
        id: 107,
        name: 'organizationSelectPage.createNewOrganization.click',
        fields: [],
      },
    },
  },
};
